/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';

import {
  FaFilter,
  FaSortAmountDown,
  FaSortAmountUpAlt,
  FaTimes,
} from 'react-icons/fa';
import Loader from '../../Loader';
import {
  ListUniqueValues,
  TransactionsColumns,
  WEB_API_BILLING,
} from '../../../assets/constants/strings';
import FilterModal from '../../Modals/FilterModal';
import Transaction from './Transaction';
import './style.scoped.scss';
import SettingsTitle from '../UIElements/SettingsTitle';

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  user: state.user.user,
  transactions: state.user.transactions,
});

const connector = connect(mapStateToProps);

const Billing = ({ transactions, loading }) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Transactions/billing history will be populated from the billing provider
  // (Paddle/Stripe) once the billing-webhooks work (#4) lands. Until then this
  // page shows the empty state below. (Removed a dead sandbox test call that
  // leaked an API token and threw an unhandled rejection on mount.)

  const [selectedOrder, setSelectedOrder] = useState('<');

  // const [refinedList, setRefinedList] = useState(
  //   transactions && transactions !== null && !transactions.reason
  //     ? transactions
  //     : []
  // );

  const [filterValue, setFilterValue] = useState('');

  // useEffect(() => {
  //   setRefinedList(
  //     transactions && transactions !== null && !transactions.reason
  //       ? transactions
  //       : []
  //   );
  //   setFilterValue('');
  // }, [transactions]);

  const isMobile = window.innerWidth < 415;
  $('[data-toggle="tooltip"]').tooltip();

  const handleOrder = () => {
    const currOrder = selectedOrder;
    currOrder === '>' ? setSelectedOrder('<') : setSelectedOrder('>');
  };

  // const handleDisplayOrderBtn = () => {
  //   return orderedList.length > 1 ? (
  //     selectedOrder === '<' ? (
  //       <p className='sort-button sort-button__order' onClick={handleOrder}>
  //         Desc. <FaSortAmountDown className='ml-2 mr-0' />
  //       </p>
  //     ) : (
  //       <p className='sort-button sort-button__order' onClick={handleOrder}>
  //         Asc. <FaSortAmountUpAlt className='ml-2 mr-0' />
  //       </p>
  //     )
  //   ) : null;
  // };

  const handlePaginationClick = (selectedItem) => {
    setSelectedPage(selectedItem.selected + 1);
  };

  // const handleApplyFilter = (DDLName, value) => {
  //   if (value.length > 0) {
  //     $('#filterModal').modal('hide');
  //     setFilterValue(value);
  //     setRefinedList(transactions.filter((item) => item[DDLName] === value));
  //   } else {
  //     setFilterValue(value);
  //     setRefinedList(transactions);
  //   }
  // };

  // if (loading || !transactions) {
  //   return (
  //     <div className='col'>
  //       <Loader />
  //     </div>
  //   );
  // }

  // const pageCount = Math.ceil(transactions.length / itemsPerPage);
  // const indexOfLastItem = selectedPage * itemsPerPage;
  // const indexOfFirstTodo = indexOfLastItem - itemsPerPage;

  // const orderedList =
  //   selectedOrder === '>'
  //     ? refinedList
  //         .sort((a, b) => (a.date > b.date ? 1 : -1))
  //         .slice(indexOfFirstTodo, indexOfLastItem)
  //     : refinedList
  //         .sort((a, b) => (a.date < b.date ? 1 : -1))
  //         .slice(indexOfFirstTodo, indexOfLastItem);

  return (
    <div className='transactions-frame' id='transactions-frame'>
      <SettingsTitle title={WEB_API_BILLING.BILLING.TITLE} />
      {/* {transactions.reason && transactions.reason === 'Session Expired.' ? (
        <div className='col main-content-wrapper' key={'index'}>
          <div className='card empty'>
            <div className='card-header font-weight-bold'>
              Session Expired. Please restart the app.
            </div>
          </div>
        </div>
      ) : transactions.length > 0 ? (
        <React.Fragment>
          <div className='transactions-header-row'>
            {filterValue.length > 0 ? (
              <div className='d-flex justify-content-end w-100 mr-3'>
                <div
                  className='sort-button'
                  onClick={() => handleApplyFilter('status', '')}
                  title='Click to remove filter'
                >
                  <FaTimes />
                  <span className='ml-3'>Status: {filterValue}</span>
                </div>
              </div>
            ) : null}
          </div>
          <div className='transactions-wrapper'>
            <div
              className={`transactions-sort-row${
                orderedList.length > 1 ? ' lg' : ''
              }`}
            >
              {TransactionsColumns.map((col, i) => (
                <div style={{ flex: col.FLEX }} key={i}>
                  <p
                    className='sort-button font-weight-bold'
                    title={col.TOOLTIP}
                    data-toggle={isMobile ? 'tooltip' : ''}
                    data-original-title={col.TOOLTIP}
                  >
                    on larger screens, show text
                    {col.ICON} {col.DISPLAY}
                  </p>
                  {col.SORT && handleDisplayOrderBtn()}
                  show filter button only if dropdown has more than one option
                  {col.FILTER &&
                  ListUniqueValues(transactions, 'status', true).length > 1 ? (
                    <div
                      className='sort-button'
                      onClick={() => $('#filterModal').modal('show')}
                    >
                      <FaFilter className='m-0' />
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className={`accordion${orderedList.length > 1 ? ' lg' : ''}`}>
              {orderedList.map((transaction, i) => (
                <Transaction
                  key={i}
                  index={i}
                  transaction={transaction}
                  isMobile={isMobile}
                />
              ))}
            </div>
            {pageCount > 1 && (
              <div className='text-center mt-5 mb-3'>
                <ReactPaginate
                  onPageChange={handlePaginationClick}
                  previousLabel={'previous'}
                  previousClassName={'paginate-previous'}
                  nextLabel={'next'}
                  nextClassName={'paginate-next'}
                  breakLabel={'...'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  containerClassName={'pagination pagination-sm'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  activeClassName={'page-item active'}
                />
              </div>
            )}
          </div>
          <FilterModal
            DDLName='status'
            modalText='Status:'
            handleApplyFilter={handleApplyFilter}
            options={ListUniqueValues(transactions, 'status', true)}
          />
        </React.Fragment>
      ) : ( */}
      <div className='col main-content-wrapper' key={'index'}>
        <div className='card empty'>
          <div className='card-header font-weight-bold'>
            No transactions have been made on this account yet.
          </div>
        </div>
      </div>
      {/* // )} */}
    </div>
  );
};

export default connector(Billing);
